var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 0.59375H2.25C1.00736 0.59375 0 1.60111 0 2.84375C0 4.08639 1.00736 5.09375 2.25 5.09375L2.25 14.0937C2.25 15.3364 3.25736 16.3437 4.5 16.3438H13.5C14.7426 16.3438 15.75 15.3364 15.75 14.0938V5.09375C16.9926 5.09375 18 4.08639 18 2.84375C18 1.60111 16.9926 0.59375 15.75 0.59375ZM3.375 14.0937L3.375 2.84375H10.125V15.2187H4.5C3.87868 15.2187 3.375 14.7151 3.375 14.0937ZM12.375 2.84375L12.375 15.2187H13.5C14.1213 15.2187 14.625 14.7151 14.625 14.0938V2.84375H12.375Z",
    fill: "#5C5E69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportIcon);
export default __webpack_public_path__ + "static/media/support-icon.05e00ab97acf9ed81c91bab3ba55d679.svg";
export { ForwardRef as ReactComponent };